import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type TCustomHeaderProps = {
  title: string;
  iconLib: string;
  iconName: string;
  iconTheme: string;
  onCancel?: () => void;
};

export const CustomHeader = ({
  title,
  iconLib,
  iconName,
  iconTheme,
  onCancel
}: TCustomHeaderProps): ReactElement => {
  return (
    <div className="modalCustomHeader">
      <div className="modalCustomHeader__iconContainer">
        <GlobalIcon
          lib={iconLib}
          name={iconName}
          theme={iconTheme}
          size={EIconSize._24}
          className="modalCustomHeader__icon"
        />
        <span className="modalCustomHeader__title">{title}</span>
      </div>

      <GlobalIcon
        lib="generic"
        name="close"
        theme="default"
        size={EIconSize._20}
        className="modal__close-icon"
        onClick={onCancel}
      />
    </div>
  );
};
